import { Link } from "react-router-dom";
import { useLanguage } from "@/lib/i18n";
import { productThumb } from "@/lib/api";

const KEY = "pruva_recently_viewed";

export const recordRecentlyViewed = (product) => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]").filter(x => x.slug !== product.slug);
    list.unshift({
      slug: product.slug,
      name: product.name,
      series: product.series,
      subtitle: product.subtitle,
      capacity: product.capacity,
      hydro_jets: product.hydro_jets,
      image_url: product.image_url,
    });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 5)));
  } catch (e) {
    console.warn("RecentlyViewed: localStorage unavailable", e);
  }
};

export const RecentlyViewed = ({ excludeSlug }) => {
  const { t, tp } = useLanguage();
  let items = [];
  try { items = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) {
    console.warn("RecentlyViewed: could not read localStorage", e);
  }
  items = items.filter(p => p.slug !== excludeSlug).slice(0, 4);

  if (items.length === 0) return null;

  return (
    <section data-testid="recently-viewed" className="py-12 md:py-16 bg-white border-t border-slate-100">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <h2 className="text-xl md:text-2xl font-medium text-slate-900 mb-8">{t("products.recentlyViewed")}</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map(p => (
            <Link key={p.slug} to={`/${p.series === 'spa' ? 'spa-series' : 'jacuzzi-series'}/${p.slug}`}
              data-testid={`recently-viewed-${p.slug}`}
              className="group bg-slate-50 overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={productThumb(p)} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = p.image_url; }}
                  alt={p.name} loading="lazy" width="300" height="225" decoding="async"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-slate-900" style={{ fontFamily: "'Inter', sans-serif" }}>{p.name}</h3>
                <p className="text-xs text-slate-500 mt-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {p.capacity} {t("products.persons")} · {p.hydro_jets} {t("products.hydroJets")}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
